import { DialogContentProps as MUIDialogContentProps } from '@mui/material'

export type DialogContentProps = MUIDialogContentProps
